import { render, staticRenderFns } from "./userStatics.vue?vue&type=template&id=7b26a6a2&scoped=true&"
import script from "./userStatics.vue?vue&type=script&lang=js&"
export * from "./userStatics.vue?vue&type=script&lang=js&"
import style0 from "./userStatics.vue?vue&type=style&index=0&id=7b26a6a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b26a6a2",
  null
  
)

export default component.exports